if (!customElements.get('blog-filter')) {
    customElements.define(
      'blog-filter',
      class BlogFilter extends HTMLElement {
        constructor() {
          super();
          this.selectElement = this.querySelector('[data-categories]');
          this.inputElement = this.querySelector('[data-search]');
          this.section = this.querySelector('[data-articles]');
          this.searchText = this.querySelector('[data-search-text]');
          this.baseUrl = window.location.origin;
          this.debounceTimer = null;
          this.featuredCarousel = this.querySelector('#featured-slider');
        }
  
        connectedCallback() {
          if (this.selectElement) {
            this.selectElement.addEventListener('change', this.handleFilterChange.bind(this));
          }
          if (this.inputElement) {
            this.inputElement.addEventListener('input', this.debounce(this.handleSearch.bind(this), 300));
          }
        }
  
        handleFilterChange(event) {
          let selectedTag = event.target.value;
          let newUrl = this.baseUrl + window.location.pathname;
          if (selectedTag && selectedTag.toLowerCase() !== 'all') {
            selectedTag = selectedTag.replace(/\s+/g, '-');
            console.log(selectedTag)
            newUrl = `${this.baseUrl + window.location.pathname}/tagged/${encodeURIComponent(selectedTag)}`;
          }
          console.log(newUrl)
          this.reloadBlogs(newUrl);
        }
  
        handleSearch(event) {
          const query = event.target.value;
          if (query.length < 3) {
            if(this.featuredCarousel) {
              this.featuredCarousel.classList.remove('hidden');
            }
            this.selectElement.classList.remove('hidden');
            this.searchText.dataset.searchText = "false";
            let newUrl = this.baseUrl + window.location.pathname;
            this.reloadBlogs(newUrl);
            return
          }
          this.selectElement.classList.add('hidden');
            this.searchText.dataset.searchText = "true";
          const searchTextSpan = this.searchText.querySelector('span');
          if (searchTextSpan) {
            searchTextSpan.textContent = query;
          }
          if(this.featuredCarousel) {
            this.featuredCarousel.classList.add('hidden');
          }
          const searchUrl = `${this.baseUrl}/search?view=news&type=article&q==${encodeURIComponent(query)}`;
          this.reloadBlogs(searchUrl);
        }
  
        debounce(func, delay) {
          return (...args) => {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => func(...args), delay);
          };
        }
  
        reloadBlogs(url) {
            if (this.abortController) {
              this.abortController.abort();
            }
            this.abortController = new AbortController();
            
            fetch(url, { signal: this.abortController.signal })
              .then((response) => {
                  if (!response.ok) {
                      this.section.innerHTML = "";
                      throw new Error('Network response was not ok');
                  }
                  return response.text();
              })
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newContent = doc.querySelector('[data-articles]');
                if (newContent && this.section) {
                  this.section.innerHTML = newContent.innerHTML;
                }
                
              })
              .catch((error) => {
                if (error.name !== 'AbortError') {
                  console.error('Error loading filtered blogs:', error);
                }
              });
          }
      }
    );
  }